import React from "react";
import { DateTime } from "luxon";
import { SignalThreadAccessEvent } from "@types";
import { getClassName } from "@utils";
import { EnvelopeIcon, GlobeIcon } from "./icons";
import css from "./AccessEventItem.module.scss";
import { Skeleton, SkeletonVariant } from "@taskpane/components";

export interface AccessEventItemProps {
  isLoading?: boolean;
  event?: SignalThreadAccessEvent;
  style?: React.CSSProperties;
}

const AccessEventItem: React.FC<AccessEventItemProps> = ({ isLoading = false, event, style }) => {
  const { recipientEmails = [] } = event?.eventMetadata || {};
  const { city = "", country = "" } = event?.eventMetadata?.location || {};
  const emailsString = recipientEmails.join(", ") || "N/A";
  const timeString = event?.accessDate
    ? DateTime.fromISO(event.accessDate).toLocal().toFormat("t").toLowerCase()
    : "N/A";
  const locationString = [city, country].filter(Boolean).join(", ") || "N/A";

  const attrs = {
    container: {
      style,
      className: getClassName(css.container, isLoading && css.containerLoading),
    },
    iconWrapper: {
      className: css.iconWrapper,
    },
    content: {
      className: css.content,
    },
    titleWrapper: {
      className: css.titleWrapper,
    },
    title: {
      className: css.title,
    },
    time: {
      className: css.time,
    },
    location: {
      className: css.location,
    },
    iconSkeleton: {
      variant: SkeletonVariant.Circle,
    },
    titleSkeleton: {
      className: css.titleSkeleton,
    },
    locationSkeleton: {
      className: css.locationSkeleton,
    },
  };

  if (isLoading) {
    return (
      <div {...attrs.container}>
        <div {...attrs.iconWrapper}>
          <Skeleton {...attrs.iconSkeleton} />
        </div>
        <div {...attrs.content}>
          <div {...attrs.titleWrapper}>
            <Skeleton {...attrs.titleSkeleton} />
            <Skeleton {...attrs.titleSkeleton} />
          </div>
          <div {...attrs.location}>
            <Skeleton {...attrs.locationSkeleton} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div {...attrs.container}>
      <div {...attrs.iconWrapper}>
        <EnvelopeIcon />
      </div>
      <div {...attrs.content}>
        <div {...attrs.titleWrapper}>
          <span {...attrs.title}>{emailsString}</span>
          <span {...attrs.time}>{timeString}</span>
        </div>
        <div {...attrs.location}>
          <GlobeIcon />
          <span>{locationString}</span>
        </div>
      </div>
    </div>
  );
};

export default AccessEventItem;
